import { cn } from "@/utils";
import { Link } from "react-router-dom";

export const RouterLink: React.FC<{
  to: string;
  onClick?: () => void;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}> = ({ to, children, className, style, onClick }) => {
  return (
    <Link
      to={to}
      onClick={onClick}
      className={cn(
        "text-muted-foreground hover:text-foreground transition-colors",
        className,
      )}
      style={style}
    >
      {children}
    </Link>
  );
};
